<template>
    <div>
        <div class="prod_info" v-for="product in draw_items">
            <product_inside
                :key="'prod_inside_' + id"
                :show_remove="show_remove"
                :show_select="show_select"
                @remove_product="remove_item"
                @select_product="select_product"
                :product="product">
            </product_inside>
        </div>
    </div>
</template>


<script>
import Product_inside from "./product_inside.vue";

export default {
    name: "product_inside_list",
    components: {Product_inside},
    props : {
        items : {
            type : Array
        },

        show_select : {
            type : Boolean,
            default : true
        },

        show_remove : {
            type : Boolean,
            default : true
        },

        active_ids : {
            type : Array,
            default: () => []
        }
    },

    methods: {

        async select_product(product_id) {
            this.$emit('on_prod_select',product_id);
        },

        async remove_item(product_id) {
            this.$emit('remove_product',product_id);
        }
    },

    computed : {

        draw_items () {
            try {
                return this.items.map(item => {

                    item.is_selected = this.active_ids.some(prod_id => parseInt(prod_id) === parseInt(item.id));
                    return item;
                })
            }
            catch (e) {

            }

            return [];
        }
    }

}
</script>

<style scoped>

</style>
